import { createContext, useContext } from 'react'
import type { BookingForm, Country, Customer } from './types'

export type BookingCtx = {
  f: BookingForm
  /** Mutate a draft copy of the form; the change is committed as a new state. */
  set: (fn: (d: BookingForm) => void) => void
  err: (id: string) => string | undefined
  clearErr: (...ids: string[]) => void
  customer: Customer | null
  pickCustomer: (c: Customer | null) => void
  countries: Country[]
  notify: (type: string, message: string) => void
  /** Set when completing a draft: what the customer entered, to weigh against. */
  draft: { id: string; by: string; kg: number[] } | null
}

export const Ctx = createContext<BookingCtx | null>(null)

export const useBooking = () => {
  const c = useContext(Ctx)
  if (!c) throw new Error('useBooking must be used inside <Ctx.Provider>')
  return c
}
